import PropTypes from "prop-types";

function SendMobile({ app, config }) {
  return <></>;
}

SendMobile.defaultProps = {
  app: null,
  config: {},
};

SendMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default SendMobile;
